﻿import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import React from 'react';

/*Custom Modal that extends the React Modal class
Example
<CustomModal
    show={showCustomModal}
    onHide={() => { setShowCustomModal(false); }}
    title={"Test Title"}
    body={<div>Test Paragraph</div>}
    buttonOne={<button type="button" className="btn btn-primary" onClick={() => {}}>Test Button 1</button>}
    buttonTwo={<button type="button" className="btn btn-primary" onClick={() => {}}>Test Button 2</button>}
    buttonThree={<button type="button" className="btn btn-primary" onClick={() => {}}>Test Button 3</button>}
    />
*/

export default function CustomModal({
  show,
  onHide,
  title,
  body,
  maxWidth = 'sm',
  buttonOne = null,
  buttonTwo = null,
  buttonThree = null,
}) {
  return (
    <Dialog
      open={show}
      onClose={(_event, reason) => {
        if (reason !== 'backdropClick') onHide();
      }}
      maxWidth={maxWidth}
      fullWidth
    >
      <DialogTitle>
        {title}
        <IconButton onClick={onHide} style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        {buttonOne != null && React.cloneElement(buttonOne)}
        {buttonTwo != null && React.cloneElement(buttonTwo)}
        {buttonThree != null && React.cloneElement(buttonThree)}
      </DialogActions>
    </Dialog>
  );
}

CustomModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.element,
  maxWidth: PropTypes.string,
  buttonOne: PropTypes.element,
  buttonTwo: PropTypes.element,
  buttonThree: PropTypes.element,
};
